























































import { Component, Prop, Vue } from 'vue-property-decorator'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T;
}

@Component({
  components: {
    VueSlider
  }
})
export default class ControlPanel extends Vue {
  @Prop()
  x0!: number

  @Prop()
  y0!: number

  @Prop({ default: false })
  disabled!: boolean

  @Prop()
  speed!: number

  @Prop({ default: true })
  pause!: boolean

  onChangeX0 (event: HTMLElementEvent<HTMLInputElement>) {
    const value = parseFloat(event.target.value) || 0
    this.$emit('update:x0', value)
  }

  onChangeY0 (event: HTMLElementEvent<HTMLInputElement>) {
    const value = parseFloat(event.target.value) || 0
    this.$emit('update:y0', value)
  }

  onChangeSpeed (value: number) {
    this.$emit('update:speed', value)
  }

  onChangePause () {
    this.$emit('update:pause', !this.pause)
  }

  onReset () {
    this.$emit('reset')
  }
}
